import { api } from '../axios'

export default {
  createPayment({ amount }) {
    return api.post('v1/payments/intent', { amount })
  }
}
